import React from "react";
import {Col, Row} from "react-bootstrap";
import {ReactSVG} from "react-svg";
import securityIcon from "@Icons/SVG/icon-security-m-orange.svg";
import {CardComponent} from "@Components/Elements";

import "./index.scss";


type SecurityPillarsCardComponentProps = {
    orderNr: number;
    elementTitle: string;
    elementSubTitle: string;
    elementDescription: string;
    elementIcon: string;
    elementInfo: string;
};


export const SecurityPillarsCardComponent:React.FC<SecurityPillarsCardComponentProps> = ({
    orderNr, elementTitle, elementSubTitle, elementDescription, elementIcon, elementInfo
}) => {


    const className = (orderNr % 2 === 0 ? 'even' : 'odd') + '-element';


    return (
        <CardComponent type={1} className={`security-page__pillars-section__cards-list__card-element security-pillars-card ${className}`}>

            <Col xs={9} xl={8} className={`security-pillars-card__main-information-section ${className}-section`}>
                <Row className={'security-pillars-card__main-information-section__content'}>
                    <Col xs={12} className={'security-pillars-card__main-information-section__header'}>
                        <span>{elementTitle}</span>
                    </Col>
                    <Col xs={12} className={'security-pillars-card__main-information-section__sub-header'}>
                        <span>{elementSubTitle}</span>
                    </Col>
                    <Col xs={12} className={'security-pillars-card__main-information-section__description'}>
                        <span>{elementDescription}</span>
                    </Col>
                </Row>
            </Col>

            <Col xs={3} xl={4} className={`security-pillars-card__additional-information-section ${className}-section`}>
                <Row className={'security-pillars-card__additional-information-section__content'}>
                    <Col xs={12} className={'security-pillars-card__additional-information-section__icon'}>
                        <ReactSVG src={elementIcon} wrapper={'span'} />
                    </Col>
                    <Col xs={12} className={'security-pillars-card__additional-information-section__info'}>
                        <span>{elementInfo}</span>
                    </Col>
                </Row>
            </Col>

        </CardComponent>
    );

};


export default SecurityPillarsCardComponent;
